import { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import PageMeta from "@/components/PageMeta";

export default function DMCA() {
  const [form, setForm] = useState({ name: "", email: "", url: "", description: "" });
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    await api.post("/dmca", form);
    setSent(true);
    toast.success("Report submitted. We'll respond within 48 hours.");
  };

  return (
    <div className="max-w-3xl mx-auto px-6 md:px-10 py-20">
      <PageMeta
        title="DMCA & copyright"
        description="Report a copyright infringement or DMCA takedown to Recipe Filer. We honour every valid notice within 24 hours and remove offending recipes fast."
        canonical="/dmca"
        keywords="Recipe Filer DMCA, DMCA takedown recipe, recipe copyright infringement, report copied recipe, cookbook copyright takedown, DMCA notice food blog, remove infringing recipe"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "WebPage",
          name: "DMCA & copyright",
          url: "https://recipefiler.com/dmca",
          description: "Report a copyright infringement or DMCA takedown to Recipe Filer.",
          inLanguage: "en-GB",
          isPartOf: { "@type": "WebSite", name: "Recipe Filer", url: "https://recipefiler.com" },
        }}
      />
      <p className="overline mb-4">DMCA / Takedown</p>
      <h1 className="font-display text-5xl md:text-6xl font-black text-rf-ink mb-6 leading-[0.95]">Report a copyright issue.</h1>
      <p className="text-rf-ink-soft mb-10 leading-relaxed">
        If a publicly listed recipe or cookbook infringes your copyright, fill out this form. We action verified takedowns within 48 business hours.
      </p>
      {sent ? (
        <div className="card-recipe text-center py-12">
          <h2 className="font-display text-3xl font-black text-rf-ink mb-3">Thank you.</h2>
          <p className="text-rf-ink-soft">We'll review your report and follow up by email.</p>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-5">
          <div>
            <label className="overline">Your name</label>
            <input data-testid="dmca-name" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="input-rf mt-1" />
          </div>
          <div>
            <label className="overline">Email</label>
            <input data-testid="dmca-email" required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="input-rf mt-1" />
          </div>
          <div>
            <label className="overline">Infringing URL</label>
            <input data-testid="dmca-url" required value={form.url} onChange={(e) => setForm({ ...form, url: e.target.value })} className="input-rf mt-1" />
          </div>
          <div>
            <label className="overline">Description of the claim</label>
            <textarea data-testid="dmca-description" required rows={6} value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} className="input-rf mt-1" />
          </div>
          <button data-testid="dmca-submit" className="btn-amber">Submit takedown notice</button>
        </form>
      )}
    </div>
  );
}
